import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { AuthContext } from "../../context/AuthContext";
import Table from "../../components/Table";
import { ArrowSphereAllColumn } from "../../components/headerContent";
import { useTranslation } from "react-i18next";
import Loader from "../../components/Loader";

export default function ArrowSphereAll() {
    const { apiUrl } = useContext(AuthContext);
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    const getArrowSphereAll = async () => {
        try {
            const res = await axios.get(`${apiUrl}microsoft/arrow/licenses/all`, {
                withCredentials: true,
            });
            return res.data;
        } catch (error) {
        }
    };

    const arrowSphereAll = useQuery({
        queryKey: ["arrowSphereAll"],
        queryFn: getArrowSphereAll,
    });

    useEffect(() => {
        queryClient.invalidateQueries(["arrowSphereAll", arrowSphereAll.data]);
    }, [arrowSphereAll.data]);

    if (arrowSphereAll.data && arrowSphereAll.data === undefined) {
        return <h1 className="page-title"> Pas de données ArrowSphere disponibles</h1>
    }

    return (
        <>
            {!arrowSphereAll.isLoading ? (
                <div className='cato-content-table mt-1'>
                    {arrowSphereAll.data && arrowSphereAll.data.length > 0 ? (
                        <Table
                            tableData={arrowSphereAll.data}
                            tableColumns={ArrowSphereAllColumn}
                            checkbox={false}
                        />
                    ) : !arrowSphereAll.data || arrowSphereAll.data.length === 0 ? (
                        <h1 className="page-title">Pas de données ArrowSphere disponibles</h1>
                    ) : (
                        <Loader />
                    )}
                </div>
            ) : (
                <Loader />
            )}
        </>
    );
}